<template>
  <div class='orderhead'>
    <div class='order-lists' v-for="item in list" :key="item.type">
      <div class='order-list-top'>
        <div :class="item.type <= isShow ? 'cover':'normal'"></div>
        <div :class="item.type < isShow ? 'active':'normals'" class="line"></div>
      </div>
      <span :class="item.type <= isShow ? 'bold':'normals'">{{item.title}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Number,
      value: 1
    }
  },
  data () {
    return {
      list: [
        { title: '下订单', type: 0 },
        { title: '支付成功', type: 1 },
        { title: '厂商确认', type: 2 },
        { title: '预定成功', type: 5 }
      ]
    }
  },
  created () {
  }
}
</script>
<style scoped>
.orderhead{
  width: 100%;
  height: auto;
  background:#FFF;
  padding: 0px 35px 15px 35px;
  box-sizing: border-box;
  display: flex;
}
.order-lists{
  flex: 1;
  display: inline-block;
  height: 100%;
  span-align: center;
  margin-top: 10px;
}
.order-lists:last-child{
  flex: none;
  width: 7%;
  span-align: center;
  margin-top: 10px;
}
.order-lists:last-child span{
  margin-left: -18px;
  width: 50px;
}
.order-lists:last-child .line{
display: none;
}
.order-list-top{
width: 100%;
float: left;
height: 20px;
line-height: 20px;
position: relative;
margin-top: 10px;
}
.orderhead div.normal{
width: 10px;
height: 10px;
z-index: 3;
position: absolute;
left: 0;
top: 5px;
background: #DDDDDD;
border-radius: 5px;
}
.orderhead div.cover{
width: 10px;
height: 10px;
top: 5px;
background: #849E00;
border-radius: 5px;
position: absolute;
left: 0;
z-index: 6;
}
.orderhead span{
float: left;
text-align: center;
width: 100%;
margin-left: -45%;
margin-top: 12px;
font-size:12px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color: #999999;
}
.orderhead span.bold{
  color: #849E00;
}
.line{
width: 96%;
height: 1px;
background:#DDDDDD;
position: absolute;
top: 10px;
left: 4px;
}
.line.active{
background: #849E00;
}
</style>
